import { BODY_TYPE_KEYS } from "@./cat-calculations";
import { snakeCaseToCamelCase } from "@utils/misc";
import { useTranslations } from "next-intl";
import { createEnumTranslations } from "./createEnumTranslations";

export const useCatBodyType = () => {
  const tBodyTypes = useTranslations("Cats.BodyTypes");
  const tVocabulary = useTranslations("Shared.Vocabulary");
  const unknown = tVocabulary("unknown");

  return createEnumTranslations({
    values: BODY_TYPE_KEYS,
    translate: (bodyType) => {
      if (bodyType === "UNKNOWN") {
        return unknown;
      }

      return tBodyTypes(`${snakeCaseToCamelCase(bodyType)}.title`);
    },
    translateDescription: (bodyType) => {
      if (bodyType === "UNKNOWN") {
        return unknown;
      }

      return tBodyTypes(`${snakeCaseToCamelCase(bodyType)}.description`);
    },
    fallback: unknown,
  });
};
